import { useLocation, Outlet, Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";

const RequireAuth = ({ allowedRoles }) => {
  const authContext = useAuth();
  const roles = authContext?.auth?.roles;
  const location = useLocation();

  // Ensure roles is an object to avoid TypeError when roles are undefined
  const safeRoles = roles || {}; // Default to an empty object if roles are undefined
  const hasRole = allowedRoles.some((role) => safeRoles[role]);

  return hasRole ? (
    <Outlet />
  ) : (
    <Navigate to="/auth/sign-in" state={{ from: location }} replace />
  );
};

export default RequireAuth;
